import FullCalendar from '@fullcalendar/react'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import { Card } from 'layouts'
import { message, Select } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useState, useCallback, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { LocationSlice, getLocationListDataAction, NavSlice, getALocationDataAction } from 'redux/reducers'
import './WeekFullCalendar.scss'
import { DatePicker } from 'antd'
import moment from 'moment'
import 'dayjs/locale/zh-cn' // 引入语言包
import updateLocale from 'dayjs/plugin/updateLocale' // 引入更新语言环境的插件
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekday from 'dayjs/plugin/weekday'

dayjs.extend(updateLocale)
dayjs.locale('zh-cn') // 使用中文语言环境

// 扩展插件
dayjs.extend(weekOfYear)
dayjs.extend(weekday)

// 其他插件...
export const WeekFullCalendar = props => {
    const { t } = useTranslation()
    const { authLocationList, typeString, typeSlice, typeApi, eventList, typeRoute } = props
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const fullCalendarRef = useRef()
    const [startDay, setStartDay] = useState() // 日历视图-开始日期
    const [endDay, setEndDay] = useState() // 日历视图-结束日期
    const [currentStart, setCurrentStart] = useState() // 日历视图-当月-开始日期
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    const selectedKeys = useSelector(state => state.NavSlice.selectedKeys)
    // 定义周起始日和周结束日
    // const [weekStart, setWeekStart] = useState(null)
    const [weekStartDate, setWeekStartDate] = useState(null)

    const locationData = useSelector(state => state.LocationSlice.locationData)
    const locationType = useSelector(state => state.LocationSlice.locationType)
    let congruentLocation
    if (locationType === '') {
        congruentLocation = false
    } else if (locationData?.length !== 1 || locationType !== 'outdoor') {
        congruentLocation = true
    }

    const locationId = useSelector(state => state.LocationSlice.locationId)
    const locationName = useSelector(state => state.LocationSlice.locationName)

    //回显
    const calendarData = useSelector(state => state[typeString].calendarData)
    const calendarInfo = useSelector(state => state[typeString].calendarInfo)
    /* 初始化日历组件钩子, el 为原生事件对象，view 为【日历视图基本信息】 */
    const viewDidMount = ({ el, view }) => {
        if (!userInfo) return
        setStartDay(dayjs(view.activeStart).format('YYYY-MM-DD'))
        setEndDay(dayjs(view.activeEnd).format('YYYY-MM-DD'))
        setCurrentStart(dayjs(view.currentStart).format('YYYY-MM-DD'))
    }
    /* 切换日期 */
    const handleDatePicker = (date, dateString) => {
        const calendarApi = fullCalendarRef.current.getApi() // 获取 api 汇总对象

        calendarApi.gotoDate(dateString) // 调用原生 api，切换日历月份
    }
    /* 操作视图函数： 加载日历，前进后退等，注意它会在组件渲染完成之前就执行 */
    const handleActionView = dateInfo => {
        if (!userInfo) return

        setStartDay(dayjs(dateInfo.view.activeStart).format('YYYY-MM-DD'))
        setEndDay(dayjs(dateInfo.view.activeEnd).format('YYYY-MM-DD'))
        setCurrentStart(dayjs(dateInfo.view.currentStart).format('YYYY-MM-DD'))
        dispatch(typeSlice.actions.addCalendarInfo(dayjs(dateInfo.view.currentStart).format('YYYY-MM-DD'))) // 切换月份，本地存储日历信息
    }

    //////////////////////////日历事件效果/////////////////////////

    /* 创建日历上的事件数据对象 */
    const getEventTitle = [
        ...(calendarData?.map(item => {
            let startDay = item.startDay
            let endDay = item.endDay

            if (typeRoute === 'acquisition_obn') {
                if (userInfo?.project?.acquisitionStartDate > startDay) {
                    startDay = userInfo?.project?.acquisitionStartDate
                }
            }
            if (typeRoute === 'activity_diary') {
                if (userInfo?.project?.activityDiaryStartDate > startDay) {
                    startDay = userInfo?.project?.activityDiaryStartDate
                }
            }
            if (typeRoute === 'receiver') {
                if (userInfo?.project?.receiverStartDate > startDay) {
                    startDay = userInfo?.project?.receiverStartDate
                }
            } else {
                if (userInfo?.project?.firstReportDate > startDay) {
                    startDay = userInfo?.project?.firstReportDate
                }
            }

            // 简化逻辑，当值为空时 title 为 null
            const titleContent = typeRoute === 'project_summary' ? item.operationSummary : item.comment
            return {
                start: startDay,
                end: endDay,
                title: titleContent, // 若 titleContent 为空字符串、undefined 或 null，title 设为 null
                // backgroundColor: 'red' , // 颜色
                id: item.id, // 事件 ID
                textColor: 'black',
                display: titleContent === '' ? 'none' : 'block',
                extendedProps: {
                    // 自定义字段，存储关联的日期或其他数据
                    startDay: startDay,
                    endDay: endDay,
                    week: item.week,
                    year: item.year,
                },
            }
        }) || []),
    ]

    //////////////////////////日历事件效果end/////////////////////////
    const selectEvent = info => {
        const extendsWeek = dayjs(info?.event?.extendedProps?.startDay).week()
        const extendsYear = info?.event?.extendedProps?.year
        const endDay = dayjs(info.startStr).endOf('week').format('YYYY-MM-DD')
        let startDay = dayjs(info.startStr).startOf('week').format('YYYY-MM-DD')

        if (typeRoute === 'acquisition_obn') {
            if (userInfo?.project?.acquisitionStartDate > startDay) {
                startDay = userInfo?.project?.acquisitionStartDate
            }
        }
        if (typeRoute === 'activity_diary') {
            if (userInfo?.project?.activityDiaryStartDate > startDay) {
                startDay = userInfo?.project?.activityDiaryStartDate
            }
        }
        if (typeRoute === 'receiver') {
            if (userInfo?.project?.receiverStartDate > startDay) {
                startDay = userInfo?.project?.receiverStartDate
            }
        } else {
            if (userInfo?.project?.firstReportDate > startDay) {
                startDay = userInfo?.project?.firstReportDate
            }
        }

        if (congruentLocation) {
            if (!locationId) {
                message.warning(t('common.tips10'))
                return
            }
        }
        if (info.startStr) {
            dispatch(typeSlice.actions.addCalendarInfo(dayjs(info.startStr).endOf('week').format('YYYY-MM-DD'))) // 点击单元格，本地存储点击的日历信息
            // dispatch(typeSlice.actions.addCalendarInfo(info.startStr)) // 点击单元格，本地存储点击的日历信息
        } else {
            dispatch(
                typeSlice.actions.addCalendarInfo(
                    dayjs(info?.event?._instance?.range?.end).subtract(1, 'day').format('YYYY-MM-DD')
                )
            ) // 点击事件，本地存储点击的日历信息
        }
        const str = new Date(info.startStr)
        const dayjsStr = dayjs(info.startStr)
        const weekNumber = dayjsStr.week() ?? extendsWeek
        const year = str.getFullYear()
        navigate(selectedKeys[0] + '/weekDetail', {
            state: {
                authLocationList,
                typeRoute,
                weekNumber: info.startStr ? weekNumber : extendsWeek,
                year: info.startStr ? year : extendsYear,
                startDay,
                endDay,
            },
        })
    }

    /* 请求日历上的数据 */
    const getCalendarData = useCallback(
        (startDay, endDay, currentWeek, id = locationId) => {
            const startWeek = dayjs(startDay).startOf('isoWeek').isoWeek()
            const endWeek = dayjs(endDay).endOf('isoWeek').isoWeek()
            const year = new Date(currentWeek).getFullYear()
            const calendarParams = {
                dateType: 'week',
                startWeek, // 日历开始日期
                endWeek, // 日历结束日期
                startDay,
                endDay,
                year,
                locationId: typeRoute === 'project_summary' ? userInfo?.user?.projectId : id, // 船 ID
                projectId: userInfo?.user?.projectId, // 项目 ID
            }

            dispatch(typeApi(calendarParams)) // 请求日历上的数据'
        },
        [locationId, userInfo]
    )
    /* 初始化 - 获取 location 数据 */
    useEffect(() => {
        if (!userInfo) return
        dispatch(getLocationListDataAction(userInfo.user.projectId))
        setWeekStartDate(userInfo.project.weekStart)
        dayjs.updateLocale('zh-cn', {
            weekStart: userInfo.project.weekStart, // 设置zh-cn的周起始日
        })

        // 设置周日为每周第一天(0=周日)
        dayjs().weekday(0)
    }, [userInfo])
    /* 初始化 - 获取日历数据 */
    useEffect(() => {
        const isTrue =
            typeRoute === 'project_summary'
                ? !userInfo || !startDay || !endDay
                : !userInfo || !startDay || !endDay || !locationId
        if (isTrue) return
        getCalendarData(startDay, endDay, currentStart) // 初始化日历上的数据
    }, [startDay, endDay, userInfo, locationId])
    /* 默认 location */
    useEffect(() => {
        if (locationData?.length === 0) return
        const result = locationData?.find(p => p.id === locationId)
        if (!result && locationData) {
            dispatch(LocationSlice.actions.addLocationId(locationData[0].id))
            dispatch(LocationSlice.actions.addLocationName(locationData[0].name))
            dispatch(LocationSlice.actions.addlocationType(locationData[0].locationType)) // 设置 location Type
        }
    }, [locationData])

    useEffect(() => {
        if (!typeRoute) return
        dispatch(getALocationDataAction(typeRoute)) // 场所信息
    }, [typeRoute])

    if (!userInfo) return <></>

    return (
        <Card className='calendar-card-week'>
            <DatePicker
                onChange={handleDatePicker}
                value={moment(currentStart)}
                picker='month'
                className='datePickerBtn'
                allowClear={false}
                disabledDate={currentDate => {
                    const current = currentDate.format('YYYY-MM-DD')
                    return current < userInfo?.project?.startDate || current > userInfo?.project?.endDate
                }}
            />
            {congruentLocation && (
                <div className='customBtn'>
                    {locationData?.length > 0 || !locationData ? (
                        <Select
                            onChange={(value, locationData) => {
                                dispatch(LocationSlice.actions.addLocationId(locationData?.id)) // 设置 location id
                                dispatch(LocationSlice.actions.addLocationName(locationData?.name)) // 设置 location 名称
                                dispatch(LocationSlice.actions.addlocationType(locationData?.type)) // 设置 location Type
                                getCalendarData(startDay, endDay, locationData?.id) // 获取日历上的数据
                            }}
                            value={locationId ? { label: locationName, value: locationId } : t('common.calendar.tips1')}
                            className={`locationBtn`}
                            options={locationData?.map(item => ({
                                label: item.name,
                                value: item.id,
                                id: item.id,
                                name: item.name,
                                type: item.locationType,
                            }))}
                        />
                    ) : (
                        <div
                            className={`locationBtn creatLocationBtn`}
                            onClick={() => {
                                const path = '/setting/resources/locations'
                                dispatch(NavSlice.actions.addSelectedKeys([path])) // 记住 menu 选中状态
                                navigate(path)
                            }}
                        >
                            {t('common.calendar.tips2')}
                        </div>
                    )}
                </div>
            )}
            {/* 周视图 */}
            <div className='weekgridBox'>
                <FullCalendar
                    contentHeight='auto' // 日历整体高度由内容决定
                    plugins={[dayGridPlugin, interactionPlugin]} // 模块插件加载
                    initialView='dayGridMonth' // 初始化视图
                    initialDate={calendarInfo ?? currentStart} // 初始化日期
                    firstDay={weekStartDate === 7 ? 0 : weekStartDate}
                    validRange={nowDate => {
                        if (userInfo) {
                            if (typeRoute === 'acquisition_obn') {
                                return {
                                    start: userInfo?.project?.acquisitionStartDate,
                                    end: dayjs(userInfo?.project?.acquisitionEndDate)
                                        .add(1, 'day')
                                        .format('YYYY-MM-DD'),
                                }
                            }
                            if (typeRoute === 'activity_diary') {
                                return {
                                    start: userInfo?.project?.activityDiaryStartDate,
                                    end: dayjs(userInfo?.project?.activityDiaryEndDate)
                                        .add(1, 'day')
                                        .format('YYYY-MM-DD'),
                                }
                            }
                            if (typeRoute === 'receiver') {
                                return {
                                    start: userInfo?.project?.receiverStartDate,
                                    end: dayjs(userInfo?.project?.receiverEndDate).add(1, 'day').format('YYYY-MM-DD'),
                                }
                            } else {
                                return {
                                    start: userInfo?.project?.firstReportDate,
                                    end: dayjs(userInfo?.project?.lastReportDate).add(1, 'day').format('YYYY-MM-DD'),
                                }
                            }
                        } else {
                            return {}
                        }
                    }} // 限制日期可显示范围在：项目开始和结束范围内
                    viewDidMount={viewDidMount} // 日历挂载 DOM 钩子
                    weekNumbers={true} // 显示周数
                    weekNumberContent={arg => {
                        const startDay = dayjs(arg.date).startOf('week').format('YYYY-MM-DD').split('-')
                        const endDay = dayjs(arg.date).endOf('week').format('YYYY-MM-DD').split('-')
                        const weekStart = startDay[2] + '/' + startDay[1] + '/' + startDay[0]
                        const weekend = endDay[2] + '/' + endDay[1] + '/' + endDay[0]
                        return (
                            <div>
                                W{arg.num} ({weekStart + ' to ' + weekend})
                            </div>
                        )
                    }}
                    dayCellDidMount={handleActionView} // 切换日期触发钩子
                    selectable // 允许点击日历
                    selectMirror // 拖动占位符
                    select={selectEvent} // 点击日历单元格
                    eventClick={selectEvent} // 点击日历事件
                    ref={fullCalendarRef} // 实例对象
                    events={getEventTitle}
                    windowResizeDelay={200} // 防止在用户拖动和调整其浏览器窗口时过于频繁地调整大小，发生 bug：https://github.com/fullcalendar/fullcalendar/issues/5935
                    buttonText={{
                        today: t('common.calendar.today'),
                    }} // 按钮文本
                    headerToolbar={{
                        start: 'prev,next',
                        center: '',
                        end: 'today',
                    }}
                />
            </div>
        </Card>
    )
}
